import React, {useContext} from 'react';
import {FormControl, FormControlLabel, FormHelperText, Grid, Radio, RadioGroup} from "@mui/material";
import Typography from "@mui/material/Typography";
import {Controller} from "react-hook-form";
import {isEmpty} from "../../../utils/GenericUtils";
import {getHelperStyle} from "../../../styles/components/FormStyle";
import {AppContext} from "../../../App";
import {languages} from "../../../strings/LanguageDictionary";


export const RadioGroupQuestion = ({
	                                   question,
	                                   control,
	                                   name,
	                                   autoFocus,
	                                   error = {},
	                                   rules = {},
	                                   defaultValue = "false",
	                                   disabled = false,
	                                   radioGroup,
                                   }) => {
	const appContext = useContext(AppContext);
	
	return (
        <React.Fragment>
            <Grid container spacing={1} direction={"row"} alignContent={"center"} alignItems={"center"} justifyContent={"center"}>
				<Grid item xs={12} sm={6}>
					<Typography variant={"subtitle1"}>
						{question}
					</Typography>
				</Grid>
				<Grid item xs={6} sm={6}>
					<FormControl variant={"outlined"} fullWidth={true} disabled={disabled} required={rules && rules.required}>
						<Controller
							as={
								radioGroup ? radioGroup :
									<RadioGroup autoFocus={autoFocus} row={true}>
										<FormControlLabel control={<Radio/>} label={languages[appContext.state.lang].QUESTION_YES} value={"true"} key={1}/>
										<FormControlLabel control={<Radio/>} label={languages[appContext.state.lang].QUESTION_NO_} value={"false"} key={2}/>
									</RadioGroup>
							}
							name={name}
							control={control}
							defaultValue={defaultValue}
							rules={rules}
						/>
						{!isEmpty(error) && <FormHelperText
							style={getHelperStyle().helperRadio}>{languages[appContext.state.lang].OCEAN__GLOBAL_REQUIRED_FILES_}</FormHelperText>
						}
					</FormControl>
				</Grid>
			</Grid>
        </React.Fragment>
    );
};
